import DealerListItem from './components/dealer-list-item/DealerListItem.vue';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: { DealerListItem },
  data() {
    return {
      valid: false,
      profile: {},
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    hasDealersAddr() {
      const list = this.profile?.dealers?.length ? [...this.profile.dealers] : [];
      return list.length
        && !list.filter(d => !d.obj?.house && !d.fact_address && !d.disabled).length;
    },
  },
  methods: {
    createUser() {
      const profile = { ...this.user };
      if (profile.distributors && profile.distributors.length > 0) {
        profile.distributors_ids = profile.distributors.map(el => el.id) || [];
      }
      if (profile.channel) {
        profile.channels = [profile.channel];
      }
      profile.dealers = profile.dealers
        .map(d => ({
          ...d,
          obj: null,
          fact_address: d.fact_address || '',
          disabled: !!d.fact_address,
        }));

      this.profile = { ...profile };

      if (this.profile.birthday_on) {
        this.birthday_on = this.parseDate(this.profile.birthday_on);
      }
    },
    ChangeDealerAddress(id, address, dadata) {
      const dealers = [...this.profile.dealers];
      const changedDealer = dealers.find(d => d.id === id);
      if (changedDealer) {
        const list = dealers.map((d) => {
          if (id === d.id) {
            return {
              ...d,
              fact_address: address,
              obj: dadata,
            };
          }
          return d;
        });
        this.$set(this.$data.profile, 'dealers', list);
      }
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          birthday_on: app.birthday_on,
          gender: app.profile.gender,
          address: app.profile.address,
          phone_mobile_local: app.profile.phone_mobile,
          phone_local: app.profile.phone,
          email: app.profile.email,
          dealers: app.profile.dealers,
        };
        app.$store.getters.axl.post('profiles/api/auth/profile-edit', profile)
          .then(async () => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            await app.$store.dispatch('GetProfile');
            app.$router.push({ name: 'dashboard' });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
    }
  },
};
